import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryTravelPlanData = Content.Components['TravelPlanModuleDto'];

interface UseQueryTravelPlanOptions {
  initialData?: UseQueryTravelPlanData;
  parameters?: Content.Components['IHotelPageHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQueryTravelPlan = ({
  initialData,
  parameters,
}: UseQueryTravelPlanOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryTravelPlanData>(
    [QueryId.TRAVEL_PLAN, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/travel-plan';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryTravelPlan', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryTravelPlan;
